import React from 'react';
import { Box } from '@mui/material';
import Iconify from '../../../components/iconify';

import { GRID_COLUMN_DRAG_ATTR } from '../../../utils/gridColumnDrag';

// Lying along the top edge of the head cell, centred — clear of the label, so
// nothing moves when it shows: on hover of the cell, and on the column being
// dragged. It takes the head text colour.
const dragGripSx = {
    'position': 'absolute',
    'top': 0,
    'left': '50%',
    'display': 'flex',
    'transform': 'translateX(-50%) rotate(90deg)',
    'color': 'inherit',
    'opacity': 0,
    'transition': 'opacity 100ms ease',
    'pointerEvents': 'none',
    [`th:hover > &, th[${GRID_COLUMN_DRAG_ATTR}="lifted"] > &`]: {
        opacity: 0.6
    }
};

/**
 * The ⠿ grip a reorderable head cell shows on hover: a hint that the column
 * can be dragged. Decoration only — the whole head cell takes the drag.
 */
export default function GridColumnDragGrip() {
    return (
        <Box aria-hidden sx={dragGripSx}>
            <Iconify icon="ic:round-drag-indicator" width={14} />
        </Box>
    );
}
